// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-field-with-spacing {
  margin-bottom: 1rem;
}

.small {
  font-size: 12px;
}

.placehoder-right::placeholder,
.placehoder-right::-webkit-input-placeholder,
.placehoder-right:-ms-input-placeholder,
.placehoder-right::-ms-input-placeholder {
  text-align: right;
}

.input-with-icon {
  position: relative;
}
.input-with-icon .custom-input {
  padding-inline-end: 2.5rem;
}
.input-with-icon .end-icon {
  position: absolute;
  top: 50%;
  inset-inline-end: 0.75rem;
  inset-block-start: 50%;
  width: 1.25rem;
  height: 1.25rem;
  transform: translateY(-50%);
  opacity: 1;
  cursor: pointer;
  transition: opacity 0.2s;
}
.input-with-icon:hover .input-with-icon .end-icon, .input-with-icon:focus-within .input-with-icon .end-icon {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/text-input-row/text-input-row.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACI,eAAA;AACJ;;AAEA;;;;EAIE,iBAAA;AACF;;AAEA;EACE,kBAAA;AACF;AACE;EACE,0BAAA;AACJ;AAEE;EACE,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;EACA,UAAA;EACA,eAAA;EACA,wBAAA;AAAJ;AAEI;EAEE,UAAA;AADN","sourcesContent":[".form-field-with-spacing {\n  margin-bottom: 1rem;\n}\n\n.small {\n    font-size: 12px;\n}\n\n.placehoder-right::placeholder,\n.placehoder-right::-webkit-input-placeholder,\n.placehoder-right:-ms-input-placeholder,\n.placehoder-right::-ms-input-placeholder {\n  text-align: right;\n}\n\n.input-with-icon {\n  position: relative;\n\n  .custom-input {\n    padding-inline-end: 2.5rem;\n  }\n\n  .end-icon {\n    position: absolute;\n    top: 50%;\n    inset-inline-end: 0.75rem;\n    inset-block-start: 50%;\n    width: 1.25rem;\n    height: 1.25rem;\n    transform: translateY(-50%);\n    opacity: 1;\n    cursor: pointer;\n    transition: opacity 0.2s;\n    \n    .input-with-icon:hover &,\n    .input-with-icon:focus-within & {\n      opacity: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
